var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"relative"},[_c('div',{staticClass:"flex items-center"},[_vm._t("default")],2),_vm._v(" "),(_vm.isScimEnabled)?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
      content: 'Synced with SCIM Provider',
      delay: { show: 0, hide: 100 }
    }),expression:"{\n      content: 'Synced with SCIM Provider',\n      delay: { show: 0, hide: 100 }\n    }"}],staticClass:"absolute bottom-0 right-0 z-10 flex items-center justify-center rounded-full bg-ink-300 shadow-md",class:{
      'h-4 w-4': _vm.size === 'small',
      'h-5 w-5': _vm.size === 'medium'
    }},[_c('ZIcon',{attrs:{"size":_vm.size === 'medium' ? 'small' : 'x-small',"icon":"fingerprint","color":"vanilla-400"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }